import { OperatorAccessLevel } from '@ps/core-models';
import { OperatorAccessLevelOption } from '../models/access-level-option.model';
import {
  BASE_OPERATOR_ACCESS_LEVELS,
  SERVICE_OPERATOR_ACCESS_LEVEL,
} from '../user.constants';

/** Ported from legacy `ManageUser.OperatorManagerAccessLevel`. */
const ASSIGNABLE_BY_LEVEL: Partial<
  Record<OperatorAccessLevel, readonly OperatorAccessLevel[]>
> = {
  full: ['limited', 'full'],
  serviceOperator: ['limited', 'full', 'serviceOperator'],
  admin: ['limited', 'full', 'serviceOperator', 'admin'],
};

/**
 * Service Operator is only offered on the PureSpectrum company. A signed-in
 * level outside the table grants nothing — the legacy code threw there.
 */
export const assignableOperatorAccessLevels = (
  signedInOperatorLevel: OperatorAccessLevel,
  companyId: number,
  pureSpectrumCompanyId: number,
): OperatorAccessLevelOption[] => {
  const assignable = ASSIGNABLE_BY_LEVEL[signedInOperatorLevel] ?? [];
  const isPureSpectrumCompany = companyId === pureSpectrumCompanyId;

  return [...BASE_OPERATOR_ACCESS_LEVELS, SERVICE_OPERATOR_ACCESS_LEVEL].filter(
    (option) =>
      assignable.includes(option.value) &&
      (isPureSpectrumCompany || option.value !== 'serviceOperator'),
  );
};
